
import React from 'react';
import { X } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { ActiveFilter } from '@/types';

interface ActiveFilterTagsProps {
  activeFilters: ActiveFilter[];
  onRemoveFilter: (filter: ActiveFilter) => void;
  onClearAllFilters: () => void;
}

export const ActiveFilterTags: React.FC<ActiveFilterTagsProps> = ({
  activeFilters,
  onRemoveFilter,
  onClearAllFilters
}) => {
  if (activeFilters.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {activeFilters.map((filter, index) => (
        <Badge 
          key={`${filter.type}-${filter.value}-${index}`}
          variant="outline"
          className="py-1 px-2 bg-accent/60 text-xs font-medium flex items-center gap-1 hover:bg-accent"
        >
          {filter.label}
          <button
            onClick={() => onRemoveFilter(filter)}
            className="ml-1 rounded-full p-0.5 hover:bg-background"
            aria-label={`Fjern filter: ${filter.label}`}
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      ))}
      
      {activeFilters.length > 1 && (
        <button
          onClick={onClearAllFilters}
          className="text-xs text-muted-foreground hover:text-foreground underline ml-2"
          aria-label="Fjern alle filtre"
        >
          Ryd alle
        </button>
      )}
    </div>
  );
};
